import type OnboardingStep from '@/types/OnboardingStep';
import {sendGTMEvent} from '@next/third-parties/google';

function inviteHouseholdButtonClicked() {
  sendGTMEvent({event: 'invite_household_clicked'});
}

function inviteHouseholdDialogCanceled() {
  sendGTMEvent({event: 'invite_household_dialog_canceled'});
}

function leaveHouseholdClicked() {
  sendGTMEvent({event: 'leave_household_clicked'});
}

function leaveHouseholdConfirmed() {
  sendGTMEvent({event: 'leave_household_confirmed'});
}

function deleteHouseholdMemberClicked() {
  sendGTMEvent({event: 'delete_household_member_clicked'});
}

function deleteHouseholdMemberConfirmed() {
  sendGTMEvent({event: 'delete_household_member_confirmed'});
}

function switchNotificationSettings(id: string, state: boolean) {
  sendGTMEvent({
    event: 'switch_notification_settings',
    value: state ? `${id}_enable` : `${id}_disable`,
  });
}

function linkSheetzModalOpened() {
  sendGTMEvent({event: 'link_sheetz_modal_opened'});
}

function startSheetzLinkingProcess() {
  sendGTMEvent({event: 'start_sheetz_linking_process'});
}

function linkEnterpriseModalOpened() {
  sendGTMEvent({event: 'link_enterprise_modal_opened'});
}

function openEnterpriseLink() {
  sendGTMEvent({event: 'open_enterprise_link'});
}

function interactWithOnboardingCta(actionKey: OnboardingStep['actionKey']) {
  sendGTMEvent({event: 'interact_with_onboarding_cta', value: actionKey});
}

const tag = {
  deleteHouseholdMemberClicked,
  deleteHouseholdMemberConfirmed,
  interactWithOnboardingCta,
  inviteHouseholdButtonClicked,
  inviteHouseholdDialogCanceled,
  linkEnterpriseModalOpened,
  linkSheetzModalOpened,
  openEnterpriseLink,
  startSheetzLinkingProcess,
  switchNotificationSettings,
  leaveHouseholdClicked,
  leaveHouseholdConfirmed,
};

export default tag;
